import UserAdvancedView from './UserAdvancedView'

export default UserAdvancedView
